import { setBackordersDashboardFilters, useBackordersDashboardFilters } from "modules/BackordersDashboard/components/BackordersDashboardFilters/hooks";
import { BACKORDERS_STORAGE_KEYS } from "modules/BackordersDashboard/storageKeys";
import { setPreference } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";
import type { REG_VIN_FILTER } from "modules/WarrantyDashboard/hooks";
import type { PAGE_SIZE } from "utils/common";

export const handleAppointmentDateRangeChange = ([start, end]: [Date | null, Date | null]) => {
  setPreference(BACKORDERS_STORAGE_KEYS.AppointmentDateFromPreference, start);
  setPreference(BACKORDERS_STORAGE_KEYS.AppointmentDateToPreference, end);

  setBackordersDashboardFilters({ appointment_date_from: start, appointment_date_to: end, page: 1 });
};

export const handleBODateRangeChange = ([start, end]: [Date | null, Date | null]) => {
  setPreference(BACKORDERS_STORAGE_KEYS.DateFromPreference, start);
  setPreference(BACKORDERS_STORAGE_KEYS.DateToPreference, end);

  setBackordersDashboardFilters({ backorder_date_from: start, backorder_date_to: end, page: 1 });
};

export const handleRegVinFilterChange = (regVinFilter: REG_VIN_FILTER) => {
  setPreference(BACKORDERS_STORAGE_KEYS.RegVinPreference, regVinFilter);
  setBackordersDashboardFilters({ reg_vin_filter: regVinFilter });
};

export const handlePageSizeChange = (pageSize: PAGE_SIZE) => {
  setPreference(BACKORDERS_STORAGE_KEYS.PageSizePreference, pageSize);
  setBackordersDashboardFilters({ page_size: pageSize, page: 1 });
};

export const useBackordersDashboardTablePaginationChange = () => {
  const filters = useBackordersDashboardFilters();

  const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: filters.page - 1, pageSize: filters.page_size }) : updater;
    setBackordersDashboardFilters({ page: newState.pageIndex + 1 });
  };

  return { handlePaginationChange };
};
